/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: assetpb/etf.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.proto = require('./etf_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.EtfServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.EtfServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Etf,
 *   !proto.proto.CreateEtfResponse>}
 */
const methodDescriptor_EtfService_CreateEtf = new grpc.web.MethodDescriptor(
  '/proto.EtfService/CreateEtf',
  grpc.web.MethodType.UNARY,
  proto.proto.Etf,
  proto.proto.CreateEtfResponse,
  /**
   * @param {!proto.proto.Etf} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CreateEtfResponse.deserializeBinary
);


/**
 * @param {!proto.proto.Etf} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CreateEtfResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CreateEtfResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.EtfServiceClient.prototype.createEtf =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.EtfService/CreateEtf',
      request,
      metadata || {},
      methodDescriptor_EtfService_CreateEtf,
      callback);
};


/**
 * @param {!proto.proto.Etf} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CreateEtfResponse>}
 *     Promise that resolves to the response
 */
proto.proto.EtfServicePromiseClient.prototype.createEtf =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.EtfService/CreateEtf',
      request,
      metadata || {},
      methodDescriptor_EtfService_CreateEtf);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ListEtfRequest,
 *   !proto.proto.ListEtfResponse>}
 */
const methodDescriptor_EtfService_ListEtf = new grpc.web.MethodDescriptor(
  '/proto.EtfService/ListEtf',
  grpc.web.MethodType.UNARY,
  proto.proto.ListEtfRequest,
  proto.proto.ListEtfResponse,
  /**
   * @param {!proto.proto.ListEtfRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ListEtfResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ListEtfRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ListEtfResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ListEtfResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.EtfServiceClient.prototype.listEtf =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.EtfService/ListEtf',
      request,
      metadata || {},
      methodDescriptor_EtfService_ListEtf,
      callback);
};


/**
 * @param {!proto.proto.ListEtfRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ListEtfResponse>}
 *     Promise that resolves to the response
 */
proto.proto.EtfServicePromiseClient.prototype.listEtf =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.EtfService/ListEtf',
      request,
      metadata || {},
      methodDescriptor_EtfService_ListEtf);
};


module.exports = proto.proto;

